var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMissingPermissions = function SvgIcMissingPermissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#B9E1F8",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    fillRule: "evenodd",
    d: "M22.721 16.902v-4.058a4.723 4.723 0 1 0-9.443 0v4.058h-.108c-.972 0-1.756.786-1.756 1.757v7.46c0 .973.786 1.758 1.756 1.758h9.659c.971 0 1.756-.787 1.756-1.757v-7.461c0-.973-.786-1.757-1.756-1.757h-.108Zm-1.756 0v-4.058a2.967 2.967 0 0 0-5.931 0v4.058h5.931Zm-2.372 5.362a1.096 1.096 0 0 0-.594-2.02 1.098 1.098 0 0 0-.593 2.02l-.485 1.838c-.075.24.078.433.348.433h1.46c.27 0 .424-.195.349-.433l-.485-1.838Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcMissingPermissions;